module.exports = __webpack_public_path__ + "b30f9e15e471a75ac85b7dc0dfa0157c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/sidebar/6.png
// module id = 561
// module chunks = 75